import React, { useState, useEffect } from "react";
import "../../styling/GalleryTab.css";
import { ImDownload3 } from "react-icons/im";
import axios from "axios";
import EventGallery from "./EventGallery";

const itemsPerPage = 12;

const ClientGalleryTab = ({ brandingColours, clientId }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [galleryImages, setGalleryImages] = useState([]);
  const [focusedEventId, setFocusedEventId] = useState(null);

 useEffect(() => {
  const fetchGallery = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/gallery/${clientId}`,
        { withCredentials: true }
      );
      console.log("Gallery data fetched:", res.data);

      const filteredGallery = (res.data.gallery || []).filter(
        (event) => event.thumbnailUrl !== null
      );

      setGalleryImages(filteredGallery);
    } catch (error) {
      console.error("Error fetching gallery:", error);
    }
  };

  fetchGallery();
}, [clientId]);


  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentImages = galleryImages.slice(startIndex, endIndex);
  const totalPages = Math.ceil(galleryImages.length / itemsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const downloadAllImages = () => {
    console.log("Downloading all images...");
    // Optional: Add ZIP download logic
  };

  if (focusedEventId) {
    return (
      <EventGallery
        eventId={focusedEventId}
        onBack={() => setFocusedEventId(null)}
        brandingColours={brandingColours}
      />
    );
  }

  return (
    <div className="gallery-container">
      <div className="image-grid" style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "16px",
        }}>
        {currentImages.map((item, index) => (
          <div
            key={index}
            className="image-item"
            style={{ position: "relative", overflow: "hidden", cursor: "pointer" }}
            onClick={() => setFocusedEventId(item.eventId)} // 🔹 Trigger focus mode
          >
            <img
              src={item.thumbnailUrl}
              alt={item.eventTitle || `Image ${index}`}
              className="img-fluid"
              style={{ width: "350px", height: "250px", display: "block" }}
            />
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.5)",
                color: "white",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                alignItems: "flex-start",
                padding: "8px 10px",
              }}
            >
              <p style={{ margin: 0, fontSize: "15px", fontWeight: "400", lineHeight: "1.2" }}>
                {new Date(item.eventDate).toLocaleDateString()}
              </p>
              <h4 style={{ margin: "2px 0 0 0", fontSize: "20px", fontWeight: "600", lineHeight: "1.2" }}>
                {item.eventTitle}
              </h4>
            </div>
          </div>
        ))}
      </div>

      <div className="pagination">
        <button
          style={{
            marginTop: "5px",
            width: "20%",
            height: "35px",
            background: brandingColours.primaryColor,
            color: brandingColours.secondaryColor,
            fontSize: "12px",
            border: "hidden",
          }}
          onClick={downloadAllImages}
        >
          <ImDownload3 /> Download All
        </button>
        {Array.from({ length: totalPages }).map((_, index) => (
          <div
            key={index}
            className="page-item"
            style={{
              backgroundColor:
                index + 1 === currentPage
                  ? brandingColours.primaryColor
                  : "transparent",
              color:
                index + 1 === currentPage
                  ? brandingColours.secondaryColor
                  : brandingColours.primaryColor,
              borderColor: brandingColours.primaryColor,
              cursor: "pointer",
              padding: "8px 16px",
              borderRadius: "4px",
              border: "1px solid",
              margin: "4px",
            }}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientGalleryTab;
